const initialState = '';

const userIdReducer = (state = initialState, { type, payload }) => {
  if (type === 'SET_COMPANY_USER_ID') {
    return payload;
  }

  return state;
};

export default userIdReducer;
